<!-- 农事作业需求管理 -->
<template>
    <div class="content">
        <!-- 顶部 Tabs -->
        <div class="header">
            <el-tabs v-model="activeTab" @tab-click="tabClick">
                <el-tab-pane v-for="(item, index) in tabArr" :key="index" :label="`${item.label}(${item.num})`"
                    :name="item.status" />
            </el-tabs>

            <!-- 搜索栏 -->
            <el-form ref="queryFormRef" :model="queryParams" :inline="true" class="header-form-item"
                @submit.native.prevent>
                <el-form-item label="地块" prop="plotId">
                    <el-select v-model="queryParams.plotId" placeholder="请选择地块" clearable filterable
                        style="max-width: 8.4vw" popper-class="selectTree" @change="handleQuery">
                        <el-option v-for="plot in plotOptions" :key="plot.id" :label="plot.plotName || plot.name"
                            :value="plot.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="服务类型" prop="serviceType">
                    <el-select v-model="queryParams.serviceType" placeholder="请选择服务类型" clearable
                        style="max-width: 8.4vw" popper-class="selectTree">
                        <el-option v-for="d in serviceTypeDict" :key="d.value" :label="d.label" :value="d.value" />
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="种植ID" prop="plantingId">
                    <el-input v-model="queryParams.plantingId" placeholder="请输入种植ID" clearable
                        @keyup.enter.native="handleQuery" />
                </el-form-item> -->
                <el-form-item label="申请人" prop="requestUserName">
                    <el-input v-model="queryParams.requestUserName" placeholder="请输入申请人姓名" clearable
                        @keyup.enter.native="handleQuery" />
                </el-form-item>
                <!-- <el-form-item label="申请开始时间">
                    <el-date-picker v-model="dateRangeRequestBeginDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']" />
                </el-form-item>
                <el-form-item label="申请结束时间">
                    <el-date-picker v-model="dateRangeRequestEndDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']" />
                </el-form-item> -->
                <!-- <el-form-item label="接单时间">
                    <el-date-picker v-model="dateRangeReceivedTime" value-format="yyyy-MM-dd HH:mm:ss" type="daterange"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']" />
                </el-form-item> -->
                <el-form-item label="完成时间">
                    <el-date-picker v-model="dateRangeEndDate" value-format="yyyy-MM-dd HH:mm:ss" type="daterange"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']" />
                </el-form-item>
                <el-form-item>
                    <el-button @click="resetQuery">重 置</el-button>
                    <el-button type="primary" @click="handleQuery">查 询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 工具栏 + 列表 -->
        <div class="main">
            <div class="main-tool">
                <el-button type="primary" icon="el-icon-plus" @click="handleAdd">申请作业</el-button>
                <!-- <el-button icon="el-icon-download" @click="handleExport">导 出</el-button> -->
            </div>
            <!--  @selection-change="handleSelectionChange" -->
            <el-table v-loading="loading" class="main-table" :data="agriServiceList">
                <!-- <el-table-column type="selection" width="55" align="center" /> -->
                  <el-table-column label="需求名称" align="center" prop="serviceName" min-width="150" show-overflow-tooltip />
                <el-table-column label="地块名称" align="center" prop="plotName" min-width="150" show-overflow-tooltip />
                <el-table-column label="服务类型" align="center" prop="serviceType" min-width="130">
                    <template #default="scope">
                        <el-tag :type="serviceTypeTagType(scope.row.serviceType)" size="mini" effect="light"
                            class="cell-tag">
                            {{ serviceTypeText(scope.row.serviceType) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="种植记录" align="center" prop="plantingName" min-width="150"
                    show-overflow-tooltip />
                <el-table-column label="面积(亩)" align="center" prop="area" min-width="100" />
                <el-table-column label="期望开始日期" align="center" prop="requestBeginDate" min-width="160">
                    <template #default="scope">
                        <span>{{ formatDate(scope.row.requestBeginDate) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="期望结束日期" align="center" prop="requestEndDate" min-width="160">
                    <template #default="scope">
                        <span>{{ formatDate(scope.row.requestEndDate) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="申请人" align="center" prop="requestUserName" min-width="120"
                    show-overflow-tooltip />
                <el-table-column label="申请人电话" align="center" prop="requestUserPhone" min-width="120" />
                <el-table-column label="服务金额" align="center" prop="serviceAmount" min-width="100" />
                <el-table-column label="状态" align="center" prop="status" min-width="100">
                    <template #default="scope">
                        <el-tag :type="statusTagType(scope.row.status)" size="mini">
                            {{ statusText(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="接单人" align="center" prop="receivedUserId" min-width="120"
                    show-overflow-tooltip />
                <el-table-column label="接单时间" align="center" prop="receivedTime" min-width="160">
                    <template #default="scope">
                        <span>{{ formatDate(scope.row.receivedTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="完成时间" align="center" prop="endDate" min-width="160">
                    <template #default="scope">
                        <span>{{ formatDate(scope.row.endDate) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150" fixed="right">
                    <template #default="scope">
                        <el-tooltip content="编辑" placement="top">
                            <el-button v-show="scope.row.status === 'draft'" link type="primary" icon="el-icon-edit"
                                @click="handleUpdate(scope.row)" />
                        </el-tooltip>
                        <el-tooltip content="发布" placement="top">
                            <el-button v-show="scope.row.status === 'draft'" link type="primary" icon="el-icon-position"
                                @click="handlePublish(scope.row)" />
                        </el-tooltip>
                        <el-tooltip content="详情" placement="top">
                            <el-button link type="primary" icon="el-icon-view" @click="handleView(scope.row)" />
                        </el-tooltip>
                        <el-tooltip content="创建飞行任务" placement="top">
                            <el-button v-show="scope.row.status === 'accepted'" link type="primary" icon="el-icon-list"
                                @click="handleAddTask(scope.row)" />
                        </el-tooltip>
                        <el-tooltip content="完成服务" placement="top">
                            <el-button v-show="scope.row.status === 'executing'" link type="success"
                                icon="el-icon-check" @click="handleComplete(scope.row)" />
                        </el-tooltip>
                        <el-tooltip content="删除" placement="top">
                            <el-button v-show="scope.row.status === 'draft' || scope.row.status === 'pending'" link
                                type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)" />
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="footer">
            <Pagination class="footer-pagination" :total.sync="queryParams.total" :pageNum.sync="queryParams.pageNum"
                :pageSizes="[12, 30, 50]" :limit.sync="queryParams.pageSize" :reset="queryParams.reset"
                @pagination="handlePageQuery" />
        </div>

        <!-- 新增/编辑/查看 弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :modal-append-to-body="false"
            :close-on-click-modal="false" :show-close="false" :destroy-on-close="true" custom-class="form-dialog"
            width="1500px" @close="cancel">
            <img class="fix-close" src="@/page/taskPage/imgs/icon_关闭.png" alt="关闭" @click="cancel" />
            <div class="dialog-content-wrapper">
                <HomeworkDetails :id="currentWorkId" :mode="dialogMode" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import NongyeApi from '../api';
import HomeworkDetails from './details.vue';
import Pagination from '@/page/taskPage/common/Pagination';

export default {
    name: 'NongyeHomeworkIndex',
    components: {
        HomeworkDetails,
        Pagination,
    },
    data () {
        return {
            // 列表
            agriServiceList: [],
            total: 0,
            loading: false,
            buttonLoading: false,
            selectedRows: [],
            // 日期范围（与 cloud-pilot-web 一致：4 个日期范围，beginXxx/endXxx 直接写 queryParams）
            dateRangeRequestBeginDate: ['', ''],
            dateRangeRequestEndDate: ['', ''],
            dateRangeReceivedTime: ['', ''],
            dateRangeEndDate: ['', ''],
            // Tabs
            activeTab: '0',
            tabArr: [
                { label: '全部', status: '0', num: 0 },
                { label: '待确认', status: 'pending', num: 0 },
                { label: '待服务', status: 'accepted', num: 0 },
                { label: '服务中', status: 'executing', num: 0 },
                { label: '已完成', status: 'completed', num: 0 },
                { label: '已取消', status: 'cancelled', num: 0 },
            ],
            // 字典（与 cloud-pilot-web 一致：value=后端存储枚举值，label=中文）
            // 服务类型：plant_protection-植保，pest_inspection-病虫巡检，harvest-采收
            serviceTypeDict: [
                { value: 'plant_protection', label: '植保', tagType: 'success' },
                { value: 'pest_inspection', label: '病虫巡检', tagType: 'warning' },
                { value: 'harvest', label: '采收', tagType: 'primary' },
            ],
            // 状态：draft-草稿，pending-待接单，accepted-已接单，executing-服务中，completed-已完成，cancelled-已取消
            statusDict: [
                { value: 'draft', label: '草稿', tagType: 'info' },
                { value: 'pending', label: '待接单', tagType: 'warning' },
                { value: 'accepted', label: '已接单', tagType: 'primary' },
                { value: 'executing', label: '服务中', tagType: 'warning' },
                { value: 'completed', label: '已完成', tagType: 'success' },
                { value: 'cancelled', label: '已取消', tagType: 'danger' },
            ],
            // 查询
            queryParams: {
                pageNum: 1,
                pageSize: 12,
                total: 0,
                reset: false, // Pagination 组件要求的 Boolean 触发器
                plotId: undefined,
                serviceType: undefined,
                requestUserName: undefined,
                status: undefined,
            },
            // 弹窗已改用子组件 HomeworkDetails 内部处理表单
            dialogVisible: false,
            dialogTitle: '',
            dialogMode: 'create', // create / edit / view
            currentWorkId: '',
            buttonLoading: false,
            // 搜索区地块下拉（独立管理）
            plotOptions: [],
            plotOptionsLoaded: false,
        };
    },
    mounted () {
        this.loadPlotOptions();
        this.getList();
    },
    methods: {
        // ======== Tabs 计数 ========
        async getStatusCount () {
            try {
                const res = await NongyeApi.agriServiceStatusCount({});
                const list = res?.data || res?.rows || res || [];
                this.tabArr.forEach((it) => { if (it.status !== '0') it.num = 0; });
                if (Array.isArray(list)) {
                    list.forEach((item) => {
                        const target = this.tabArr.find((it) => it.status === item.status);
                        if (target) target.num = item.count ?? item.num ?? 0;
                    });
                }
                const all = this.tabArr.find((it) => it.status === '0');
                if (all) {
                    all.num = this.tabArr.filter((it) => it.status !== '0').reduce((s, it) => s + (it.num || 0), 0);
                }
            } catch (e) {
                console.warn('[homework] getStatusCount 失败', e);
            }
        },
        tabClick (tab) {
            if (tab.name === '0') {
                delete this.queryParams.status;
            } else {
                this.queryParams.status = tab.name;
            }
            this.queryParams.pageNum = 1;
            this.getList();
        },
        // ======== 列表 ========
        async getList () {
            this.loading = true;
            // 构造后端期望的 beginXxx / endXxx 时间范围字段
            // 后端 AgriServiceQuery 字段：beginReceivedTime / endReceivedTime / beginEndDate / endEndDate / beginRequestBeginDate / endRequestBeginDate / beginRequestEndDate / endRequestEndDate
            this.queryParams.beginReceivedTime = this.dateRangeReceivedTime?.[0] || undefined;
            this.queryParams.endReceivedTime = this.dateRangeReceivedTime?.[1] || undefined;
            this.queryParams.beginEndDate = this.dateRangeEndDate?.[0] || undefined;
            this.queryParams.endEndDate = this.dateRangeEndDate?.[1] || undefined;
            this.queryParams.beginRequestBeginDate = this.dateRangeRequestBeginDate?.[0] || undefined;
            this.queryParams.endRequestBeginDate = this.dateRangeRequestBeginDate?.[1] || undefined;
            this.queryParams.beginRequestEndDate = this.dateRangeRequestEndDate?.[0] || undefined;
            this.queryParams.endRequestEndDate = this.dateRangeRequestEndDate?.[1] || undefined;
            try {
                const res = await NongyeApi.listAgriService(this.queryParams);
                this.agriServiceList = res?.rows || res?.data || (Array.isArray(res) ? res : []);
                this.queryParams.total = res?.total ?? this.agriServiceList.length;
            } catch (e) {
                console.error('[homework] getList 失败', e);
                this.agriServiceList = [];
                this.queryParams.total = 0;
            } finally {
                this.loading = false;
                this.getStatusCount();
            }
        },
        handleQuery () {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        // Pagination 组件的 @pagination 事件：val = { rows, page }
        handlePageQuery (val) {
            this.queryParams.pageSize = val.rows;
            this.queryParams.pageNum = val.page;
            this.getList();
        },
        resetQuery () {
            this.dateRangeRequestBeginDate = ['', ''];
            this.dateRangeRequestEndDate = ['', ''];
            this.dateRangeReceivedTime = ['', ''];
            this.dateRangeEndDate = ['', ''];
            this.queryParams = {
                pageNum: 1,
                pageSize: 10,
                plotId: undefined,
                serviceType: undefined,
                requestUserName: undefined,
                status: this.queryParams.status,
            };
            this.handleQuery();
        },
        handleSelectionChange (selection) {
            this.selectedRows = selection;
        },
        // 搜索区地块下拉（独立管理，不与 HomeworkDetails 内的弹窗地块下拉共享）
        async loadPlotOptions (force = false) {
            if (this.plotOptionsLoaded && !force) return;
            try {
                const res = await NongyeApi.listAgriPlot({ pageNum: 1, pageSize: 1000 });
                this.plotOptions = res?.rows || res?.data || (Array.isArray(res) ? res : []);
                this.plotOptionsLoaded = true;
            } catch (e) {
                console.error('[homework] loadPlotOptions 失败', e);
                this.plotOptions = [];
            }
        },
        // 弹窗改用 iframe 后只保留显示/隐藏
        cancel () {
            this.dialogVisible = false;
        },
        // ======== 弹窗（iframe 形式） ========
        openDialog (mode, row) {
            this.currentWorkId = row?.id || '';
            this.dialogMode = mode;
            this.dialogTitle = {
                create: '新增农事作业需求',
                edit: '编辑农事作业需求',
                view: '查看农事作业需求',
            }[mode] || '';
            this.dialogVisible = true;
        },
        // 新增
        handleAdd () {
            this.openDialog('create');
        },
        // 编辑
        handleUpdate (row) {
            console.log('编辑', row);

            this.openDialog('edit', row);
        },
        // 查看
        handleView (row) {
            console.log('查看', row);
            this.openDialog('view', row);
        },
        // ======== 状态流转 ========
        async handlePublish (row) {
            try {
                await this.$confirm('确认发布该作业需求？发布后状态将变为"待服务"。', '提示', { type: 'warning' });
            } catch (e) {
                return;
            }
            try {
                await NongyeApi.updateAgriService({ ...row, status: 'pending' });
                this.$message.success('发布成功');
                await this.getList();
            } catch (e) {
                this.$message.error(e?.message || '发布失败');
            }
        },
        async handleComplete (row) {
            try {
                await this.$confirm('确认将该服务标记为已完成？', '提示', { type: 'warning' });
            } catch (e) {
                return;
            }
            try {
                const endDate = new Date().toISOString().replace('T', ' ').slice(0, 19);
                await NongyeApi.updateAgriService({ ...row, status: 'completed', endDate });
                this.$message.success('已完成');
                await this.getList();
            } catch (e) {
                this.$message.error(e?.message || '操作失败');
            }
        },
        async handleAddTask (row) {
            this.$message.info(`创建飞行任务：${row.plotName || row.id}（功能待接入）`);
        },
        // ======== 删除 / 导出 ========
        async handleDelete (row) {
            const _id = row?.id;
            if (!_id) return;
            try {
                await this.$confirm('确认删除该作业？', '提示', { type: 'warning' });
            } catch (e) {
                return;
            }
            try {
                await NongyeApi.delAgriService(_id);
                this.$message.success('删除成功');
                await this.getList();
            } catch (e) {
                this.$message.error(e?.message || '删除失败');
            }
        },
        handleExport () {
            NongyeApi.exportAgriService(this.queryParams).catch((e) => {
                this.$message.error(e?.message || '导出失败');
            });
        },
        // ======== 工具 ========
        serviceTypeText (v) {
            return (this.serviceTypeDict.find((d) => d.value === v) || {}).label || v || '-';
        },
        serviceTypeTagType (v) {
            return (this.serviceTypeDict.find((d) => d.value === v) || {}).tagType || '';
        },
        statusText (v) {
            return (this.statusDict.find((d) => d.value === v) || {}).label || v || '-';
        },
        statusTagType (v) {
            return (this.statusDict.find((d) => d.value === v) || {}).tagType || '';
        },
        formatDate (v) {
            if (!v) return '-';
            return String(v).replace('T', ' ').slice(0, 19);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/global/common.scss';

* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-size: 14px;
}

.content {
    height: 100%;
    background-color: #03053d;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    &::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        z-index: -2;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #071150;
    }

    .header {
        padding: 0;
        border-bottom: 1px solid #1a47a4;
        padding: 0 8px;

        &::v-deep .el-tabs__item {
            color: #fff;
            font-size: 14px;
        }

        &::v-deep .el-tabs__item.is-active {
            color: #49f0fd;
        }

        &::v-deep .el-tabs__active-bar {
            background-color: #49f0fd;
        }

        &::v-deep .el-tabs__nav-wrap::after {
            background-color: #112d7b;
        }

        .header-form-item {
            &::v-deep .el-form-item__label {
                color: #fff;
                line-height: 40px;
                font-size: 14px;
            }

            &::v-deep .el-input__inner {
                background-color: #112d7b !important;
                border: 1px solid #1a47a4 !important;
                box-sizing: border-box;
                color: #fff;
                max-width: 12vw;
                height: 40px;
            }

            &::v-deep .el-date-editor--daterange {
                width: 100%;
            }

            &::v-deep .el-date-editor {
                width: 18vw;
                height: 40px;
            }

            &::v-deep .el-range-editor--small .el-range-input {
                background-color: transparent;
                color: #fff;
            }

            &::v-deep .el-range-separator {
                color: #fff !important;
                line-height: 32px;
            }

            &::v-deep .el-button {
                padding: 0 14px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                color: #49f0fd;
                background: rgba(73, 240, 253, 0.2);
                border: 1px solid rgba(73, 240, 253, 0.4);
                border-radius: 2px;
                margin-left: 48px;
            }

            &::v-deep .el-button.el-button--primary {
                color: #071150;
                background: linear-gradient(181deg, #1dc9ff 0%, #49f0fd 100%);
                margin-left: 8px;
            }
        }
    }

    .main {
        flex: 1;
        min-height: 0;
        margin: 0;
        background-color: #071150;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        padding: 0 8px;

        .main-tool {
            flex-shrink: 0;
            width: 100%;
            line-height: 52px;
            text-align: right;
            padding-right: 15px;

            &::v-deep .el-button {
                padding: 0 14px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                color: #49f0fd;
                background: rgba(73, 240, 253, 0.2);
                border: 1px solid rgba(73, 240, 253, 0.4);
                border-radius: 2px;
            }

            &::v-deep .el-button.el-button--primary {
                color: #071150;
                background: linear-gradient(181deg, #1dc9ff 0%, #49f0fd 100%);
            }
        }

        .main-table {
            background-color: #071150;
            flex: 1;

            &::v-deep .el-button {
                background: none;
                border: 0;
                color: #7aa4f8;
            }
        }

        &::v-deep .el-table td.el-table__cell div {
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &::v-deep .el-table__empty-block {
            background: #071150;
            color: #fff;
            font-size: 18px;
        }

        &::v-deep .el-table__empty-text {
            font-size: 14px;
            line-height: 0;
            color: #fff;
            height: 50vh;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &::v-deep .el-table tr {
            background: #071150;
        }

        &::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
            background-color: rgba(255, 255, 255, 0.1);
        }

        &::v-deep .el-table th.el-table__cell {
            background: #112d7b;
            color: #fff;
            font-size: 14px;
            text-align: center;
        }

        &::v-deep .el-table td.el-table__cell,
        .el-table th.el-table__cell.is-leaf {
            border: 1px solid rgba(0, 0, 0, 0);
            color: #fff;
            font-size: 14px;
            text-align: center;
        }

        &::v-deep .el-table--fit {
            background-color: #071150;
        }

        &::v-deep .el-table--small .el-table__cell {
            border-bottom: none;
        }

        // 单元格内 tag 饱满化（服务类型 / 状态 / 等）
        &::v-deep .el-table .cell-tag.el-tag {
            padding: 0 12px;
            height: 24px;
            line-height: 22px;
            font-size: 12px;
            border-radius: 4px;
            border: 1px solid currentColor;
            background: rgba(73, 240, 253, 0.15);
            color: #49f0fd;

            &.el-tag--success {
                background: rgba(125, 245, 176, 0.18);
                color: #7df5b0;
                border-color: #7df5b0;
            }

            &.el-tag--warning {
                background: rgba(239, 130, 0, 0.18);
                color: #ffb060;
                border-color: #ffb060;
            }

            &.el-tag--primary {
                background: rgba(73, 240, 253, 0.18);
                color: #49f0fd;
                border-color: #49f0fd;
            }

            &.el-tag--info {
                background: rgba(180, 200, 230, 0.18);
                color: #b8d4f0;
                border-color: #b8d4f0;
            }

            &.el-tag--danger {
                background: rgba(245, 108, 108, 0.18);
                color: #f56c6c;
                border-color: #f56c6c;
            }
        }

    }

    // ====== 全局兜底：消除 el-table 所有内部边框/横线（不嵌在 .main-table 里） ======
    &::v-deep .el-table {
        border: 0;

        &::before,
        &::after {
            display: none !important;
        }
    }

    &::v-deep .el-table__inner-wrapper {
        border: 0;

        &::after,
        &::before {
            display: none !important;
        }
    }

    &::v-deep .el-table--border::after,
    &::v-deep .el-table--border::before {
        display: none !important;
    }

    &::v-deep .el-table__fixed {
        box-shadow: none !important;
    }

    &::v-deep .el-table__fixed-right-patch {
        background: transparent !important;
        border: 0 !important;
    }

    &::v-deep .el-table tr td {
        border-bottom: 0 !important;
    }

    .footer {
        flex-shrink: 0;
        padding: 18px 24px;
        background: #071150;

        &::v-deep .el-pagination {
            color: #fff;
        }

        &::v-deep .el-pagination .btn-prev,
        &::v-deep .el-pagination .btn-next,
        &::v-deep .el-pager li {
            background: transparent;
            color: #fff;
        }

        &::v-deep .el-pager li.is-active {
            color: #49f0fd;
        }
    }

    ::v-deep .el-radio {
        color: #fff;
    }

    ::v-deep .el-dialog {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        margin-top: 0 !important;
        background: #071150;
        box-shadow: inset 0 0 10px 0 #49f0fd;
        border: 1px solid #49f0fd;

        .el-dialog__header {
            padding: 18px 0 18px 24px;
            border-bottom: 1px solid #49f0fd;
            box-shadow: inset 0 0 10px 0 #49f0fd;

            .el-dialog__title {
                height: 21px;
                font-size: 16px;
                font-weight: 400;
                color: #49f0fd;
                line-height: 19px;
            }
        }

        .el-dialog__body {
            background: #071150;

            .el-input__inner,
            .el-textarea__inner {
                background-color: #071150;
                border: 1px solid rgba(135, 161, 216, 0.7);
                color: #49f0fd;
                font-size: 14px;
            }

            .el-form-item.is-error .el-input__inner {
                border-color: #f56c6c;
            }

            .el-form-item__label {
                color: #fff !important;
                font-size: 14px;
            }

            .el-button {
                width: 144px;
                height: 34px;
                font-size: 14px;
                background: rgba(73, 240, 253, 0.2);
                border-radius: 2px;
                border: 1px solid #49f0fd;
            }

            .el-button--primary {
                color: #fff;
            }
        }

        .el-dialog__footer {
            background: #071150;

        }

        // 兼容 service/index.vue 的 form-dialog 弹窗样式（iframe 弹窗用）
        &.form-dialog,
        &.task-form-dialog,
        &.confirm-form-dialog {
            .el-dialog__body {
                // 不加 padding，让 iframe 直接贴顶/贴底
                // 弹窗内第一行表单自带 element-ui 默认 padding，视觉上有间距
                padding: 0;
                background: transparent;
            }

            .dialog-content-wrapper {
                width: 100%;
                height: 100%;
            }
        }
    }

    // 关闭按钮（与 service/index.vue 一致：右上角 -20px -20px 浮出）
    .fix-close {
        position: absolute;
        top: -28px;
        right: -28px;
        cursor: pointer;
        z-index: 9999;
        width: 48px;
        height: 48px;
        object-fit: contain;
    }
}
</style>
<style lang="scss">
.el-table__fixed-right{
    &::before{
        background-color: transparent;
        border: 0 !important;
    }
}
</style>
